module.exports = __webpack_public_path__ + "assets/0ad4f7c9a4ea850469877e47e4f94165.svg";